import { stripTimeFromDate } from '../../../../shared/utils';
import { FilteredAnalyticsDTO } from '../dtos/FilteredAnalytics.dto';
import { FilteredAnalyticsModel } from '../models/FilteredAnalytics.model';

export class FilteredAnalyticsUtil {
  public static mapToViewModel(
    dto: FilteredAnalyticsDTO,
  ): FilteredAnalyticsModel[] {
    let cache: Record<string, FilteredAnalyticsModel> = {};
    const defaultAnayltic: FilteredAnalyticsModel = {
      communities: 0,
      content: 0,
      conversions: 0,
      members: 0,
      notifications: 0,
      views: 0,
      guests: 0,
      upgrade: 0,
      openConversions: 0,
      openViews: 0,
      label: stripTimeFromDate(new Date(), true),
    };

    const keyArray = Object.keys(dto);

    for (const key of keyArray) {
      const values = dto[key as keyof FilteredAnalyticsDTO];

      values.map((item) => {
        const keyValue = String(new Date(item.date).getTime());
        if (cache[keyValue]) {
          cache = {
            ...cache,
            [keyValue]: {
              ...cache[keyValue],
              label: stripTimeFromDate(new Date(item.date), true),
              [key]: item.count,
            },
          };
        } else {
          cache = {
            ...cache,
            [keyValue]: {
              ...defaultAnayltic,
              label: stripTimeFromDate(new Date(item.date), true),
              [key]: item.count,
            },
          };
        }
      });
    }

    const sorted = Object.values(cache).sort((a, b) => {
      return new Date(a.label).getTime() - new Date(b.label).getTime();
    });

    return sorted;
  }
}
